import { AzureCustomizationsLight } from '@uifabric/azure-themes';
import { Theme } from '@fluentui/theme';

export const AzureLightTheme: Theme = AzureCustomizationsLight.settings.theme;
